import { getAllTimezones } from 'countries-and-timezones'

export const normalizeTimezones = tz => {
  if (!tz) return ''
  if (!tz.includes('/')) return tz
  const [region, subRegion, city = subRegion] = tz.replaceAll('_', ' ').split('/')
  if (subRegion !== city) {
    return `${region}: ${city ?? ''} (${subRegion ?? ''})`
  }
  return `${region}${city ? ':' : ''} ${city ?? ''}`
}

export const getAllCountriesTimezones = () => Object.values(getAllTimezones())
  .reduce((acc, { name, countries }) => (
    countries.length
      ? [...acc, { label: normalizeTimezones(name), value: name }]
      : acc
  ), [])
